import { supabase } from "@/lib/supabase"
import { safeRandomUUID } from "@/lib/utils"

type AuthAnalyticsEvent = "SIGNED_IN" | "TOKEN_REFRESHED" | "USER_UPDATED" | "INITIAL_SESSION" | "UNKNOWN"

function getOrCreateDeviceId(): string {
  const key = "dpm_device_id"
  try {
    const existing = localStorage.getItem(key)
    if (existing) return existing
    const next = safeRandomUUID()
    localStorage.setItem(key, next)
    return next
  } catch {
    return safeRandomUUID()
  }
}

function getOrCreateSessionId(): string {
  const key = "dpm_session_id"
  try {
    const existing = sessionStorage.getItem(key)
    if (existing) return existing
    const next = safeRandomUUID()
    sessionStorage.setItem(key, next)
    return next
  } catch {
    return safeRandomUUID()
  }
}

function getDeviceInfo() {
  const ua = navigator.userAgent || ""
  const platform = (navigator as any)?.userAgentData?.platform || navigator.platform || ""
  const languages = Array.isArray(navigator.languages) ? navigator.languages : []
  return {
    ua,
    platform,
    languages,
    viewport: { w: window.innerWidth, h: window.innerHeight },
  }
}

export async function recordAuthAnalytics(event: AuthAnalyticsEvent, sessionId?: string | null) {
  try {
    const device_id = getOrCreateDeviceId()
    const device = getDeviceInfo()
    const session_id = sessionId || getOrCreateSessionId()
    await supabase.functions.invoke("auth_analytics", {
      method: "POST",
      body: {
        event,
        session_id,
        device_id,
        device,
      },
    })
  } catch {
    void 0
  }
}
